// extracted by mini-css-extract-plugin
export default {"splitFieldWrapper":"splitFieldWrapper---bAaHK","splitFieldRoot":"splitFieldRoot---fzyJW"};